import {RouterProvider} from "react-router";
import {Box} from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {ThemeModeProvider} from "context/ThemeProvider";
import {NotificationSystem} from "services/notification";
import router from "./router";
import {AppSetupProvider} from "context/AppSetupProvider";
import {useBrandId} from "./brand";
import {useEffect} from "react";
import {useRefreshTokenMutation} from "auth/api";
import {setAtom, useAtom} from "utils/atom";
import {userAtom} from "./user";
import socket from "services/socket";
import LoginPage from "auth/Login";
import CenterContainer from "components/CenterContainer";
import LoadingScreen from "components/ScreenState/Loading";

const App = () => {
  const brandId = useBrandId();
  const authUser = useAtom(userAtom);

  const [refreshToken] = useRefreshTokenMutation();

  useEffect(() => {
    refreshToken()
      .then(user => setAtom(userAtom, user))
      // Show error if not 406
      .catch(() => setAtom(userAtom, undefined));
  }, []);

  useEffect(() => socket.reconnect(brandId), [brandId, authUser]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ThemeModeProvider>
        {authUser === null && (
          <CenterContainer>
            <LoadingScreen />
          </CenterContainer>
        )}
        {authUser === undefined && <LoginPage />}
        {authUser && (
          <AppSetupProvider key={brandId}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                minHeight: "100vh",
              }}>
              <Box sx={{flex: 1, overflowY: "auto"}}>
                <RouterProvider router={router} />
              </Box>
              <NotificationSystem />
            </Box>
          </AppSetupProvider>
        )}
      </ThemeModeProvider>
    </LocalizationProvider>
  );
};

export default App;
